import { render, staticRenderFns } from "./AddUpdateRole.vue?vue&type=template&id=5e0b8d52&scoped=true&"
import script from "./AddUpdateRole.vue?vue&type=script&lang=js&"
export * from "./AddUpdateRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b8d52",
  null
  
)

export default component.exports